const styles = () => ({
  container: {
    display: 'flex',
    alignItems: 'center'
  },
  name: {
    color: '#666'
  },
  icon: {
    borderRadius: '100%',
    width: '25px',
    height: '25px',
    marginRight: '8px',
    flexShrink: 0,
    color: '#9b9b9b',
    border: '1px solid',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    '& svg': {
      width: '14px'
    }
  }
})

export default styles
